import { baseApi } from "common/redux/core/api.base";
import { ApiCacheTags } from "common/models/api-base.model";
import { ConfigurationHubService } from "../../services/configuration-hub.service";
import { ListParams } from "../../models/configuration-hub.model";

const assignmentApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAllAssignments: build.query<any, ListParams>({
      queryFn: (listParams: ListParams) => {
        return ConfigurationHubService.getAllAssignments(listParams);
      },
      providesTags: ["ASSIGNMENTS"] // Using assignments cache tag
    }),

    getAssignmentById: build.query<any, number>({
      queryFn: (assignmentId: number) => {
        return ConfigurationHubService.getAssignmentById(assignmentId);
      },
      providesTags: (result, error, id) => [
        { type: "ASSIGNMENTS" as const, id }
      ]
    }),

    getConfigurationOperations: build.query<any, number | undefined>({
      queryFn: (assignmentId?: number) => {
        if (!assignmentId) {
          // Return empty result if no assignment ID
          return { data: [] };
        }
        return ConfigurationHubService.getConfigurationOperations(assignmentId);
      },
      providesTags: (result, error, assignmentId) => [
        { type: "ASSIGNMENTS" as const, id: assignmentId }
      ]
    })
  })
});

export const {
  useGetAllAssignmentsQuery,
  useGetAssignmentByIdQuery,
  useGetConfigurationOperationsQuery
} = assignmentApi;
